import React from 'react'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import DocumentRepositoryAccountListUI from '../../../components/superUser/account/DocumentRepositoryAccountListUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const DocumentRepositoryAccountListPageUI = ({ context, errorList, accountList, filteredAccountList,
  onRefreshClick, onRowClick, searchFilter, onSearchFilterChange, onCopyToClipboard, copyToClipboardText
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_acc_l'
    centered={!accountList && !errorList || accountList && accountList.length === 0}
    page='documentRepository'
  >
    {
      !accountList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountList &&
      <div>
<DocumentRepositoryAccountListUI context={context} accountList={filteredAccountList}
          onRowClick={onRowClick}
          onRefreshClick={onRefreshClick}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          onCopyToClipboard={onCopyToClipboard}
          copyToClipboardText={copyToClipboardText}
        />
      </div>
    }
  </SuperUserHomePageUI>

export default DocumentRepositoryAccountListPageUI